// auto-generated by Typewriter template _enums.tst from PortCall.Models\Issues\Issue.cs
export enum IssueSeverity { 
    Information = 0,
    Warning = 1,
    Conflict = 2,
    Error = 3
}

export const IssueSeverityDisplayName : { [val : number] : string } = { 
    0: 'Information',
    1: 'Warning',
    2: 'Conflict',
    3: 'Error'
}

export const IssueSeveritys : { Id : IssueSeverity, Name : string }[] = [ 
    { Id: IssueSeverity.Information, Name: 'Information' },
    { Id: IssueSeverity.Warning, Name: 'Warning' },
    { Id: IssueSeverity.Conflict, Name: 'Conflict' },
    { Id: IssueSeverity.Error, Name: 'Error' }
]

export enum DiscrepantScheduleDateField { 
    Estimated = 0,
    Actual = 10
}

export const DiscrepantScheduleDateFieldDisplayName : { [val : number] : string } = { 
    0: 'Estimated',
    10: 'Actual'
}

export const DiscrepantScheduleDateFields : { Id : DiscrepantScheduleDateField, Name : string }[] = [ 
    { Id: DiscrepantScheduleDateField.Estimated, Name: 'Estimated' },
    { Id: DiscrepantScheduleDateField.Actual, Name: 'Actual' }
]



// WEBPACK FOOTER //
// ./server/enums/Issue.ts